angular.module('zc.commonApi')

  .factory('MongoCampaignInterestWidgetStatsWithoutBounces', MongoCampaignInterestWidgetStatsWithoutBounces);


MongoCampaignInterestWidgetStatsWithoutBounces.$inject = ['$q', 'FacadeV2'];
function MongoCampaignInterestWidgetStatsWithoutBounces($q, FacadeV2) {
  const service = {
    find
  };

  return service;

  function find(paths, query = {}, options = {}) {
    if(!paths.apikey) {
      console.error('No apikey in query');
      return $q.reject('No apikey in query');
    }

    if(!paths.dimension) {
      console.error('No dimension defined');
      return $q.reject('No dimension defined');
    }


    if(!query.start_at) {
      console.error('No start_at in query');
      return $q.reject('No start_at in query');
    }

    const promise = FacadeV2.request(`/apikeys/${paths.apikey}/campaign_interest_widget_stats_without_bounces/${paths.dimension}/find`, {
      params: {
        match: query,
        sort: options.sort,
        limit: options.limit || 1000,
      }
    }).then(res => {
      if(res.status !== 200 || res.data.error) {
        $q.reject(res.data.error);
      } else {
        return res.data;
      }
    });

    return promise;
  }
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/mongo_campaign_interest_widget_stats_without_bounces.service.js